var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoginPolygon = function SvgLoginPolygon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 1020,
    viewBox: "0 0 960 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5461_367233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 960,
    height: 1020
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1020,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5461_367233)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.5 899L716 947.804M798.5 899L881 947.804M798.5 899L798.5 1095M716 947.804L716 1045.93M716 947.804L881 1045.93M716 1045.93L798.5 1095M716 1045.93L881 947.804M798.5 1095L881 1045.93M881 1045.93L881 947.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 899L881.5 947.804M964 899L1046.5 947.804M964 899L964 1095M881.5 947.804L881.5 1045.93M881.5 947.804L1046.5 1045.93M881.5 1045.93L964 1095M881.5 1045.93L1046.5 947.804M964 1095L1046.5 1045.93M1046.5 1045.93L1046.5 947.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.5 752L799 800.804M881.5 752L964 800.804M881.5 752L881.5 948M799 800.804L799 898.935M799 800.804L964 898.935M799 898.935L881.5 948M799 898.935L964 800.804M881.5 948L964 898.935M964 898.935L964 800.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716 752L633.5 800.804M716 752L798.5 800.804M716 752L716 948M633.5 800.804L633.5 898.935M633.5 800.804L798.5 898.935M633.5 898.935L716 948M633.5 898.935L798.5 800.804M716 948L798.5 898.935M798.5 898.935L798.5 800.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.5 899L551 947.804M633.5 899L716 947.804M633.5 899L633.5 1095M551 947.804L551 1045.93M551 947.804L716 1045.93M551 1045.93L633.5 1095M551 1045.93L716 947.804M633.5 1095L716 1045.93M716 1045.93L716 947.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.5 899L386 947.804M468.5 899L551 947.804M468.5 899L468.5 1095M386 947.804L386 1045.93M386 947.804L551 1045.93M386 1045.93L468.5 1095M386 1045.93L551 947.804M468.5 1095L551 1045.93M551 1045.93L551 947.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.5 605.312L716 654.116M798.5 605.312L881 654.116M798.5 605.312L798.5 801.312M716 654.116L716 752.247M716 654.116L881 752.247M716 752.247L798.5 801.312M716 752.247L881 654.116M798.5 801.312L881 752.247M881 752.247L881 654.116",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.5 605.312L881 654.116M963.5 605.312L1046 654.116M963.5 605.312L963.5 801.312M881 654.116L881 752.247M881 654.116L1046 752.247M881 752.247L963.5 801.312M881 752.247L1046 654.116M963.5 801.312L1046 752.247M1046 752.247L1046 654.116",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 458L798.5 506.804M881 458L963.5 506.804M881 458L881 654M798.5 506.804L798.5 604.935M798.5 506.804L963.5 604.935M798.5 604.935L881 654M798.5 604.935L963.5 506.804M881 654L963.5 604.935M963.5 604.935L963.5 506.804",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.5 311L881 359.804M963.5 311L1046 359.804M963.5 311L963.5 507M881 359.804L881 457.935M881 359.804L1046 457.935M881 457.935L963.5 507M881 457.935L1046 359.804M963.5 507L1046 457.935M1046 457.935L1046 359.804",
    stroke: "white",
    strokeWidth: 2
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoginPolygon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "login-polygon.7baf9c720cd59d28332dd0e1f42d5737.svg";